import { jsx } from '@emotion/react/jsx-runtime';
import { createComponentWithRef, useSlot } from '@nettbureau/core';
import { AppearInOut } from './transitions/appear-in-out.js';
import { CollapseInOut } from './transitions/collapse-in-out.js';
import { FadeInOut } from './transitions/fade-in-out.js';
import { RevealInOut } from './transitions/reveal-in-out.js';
import { ScaleInOut } from './transitions/scale-in-out.js';
import { SlideInOut } from './transitions/slide-in-out.js';

/**
 * Map of transition types to their corresponding components.
 */ const transitionsMap = {
    appear: AppearInOut,
    collapse: CollapseInOut,
    fade: FadeInOut,
    reveal: RevealInOut,
    scale: ScaleInOut,
    slide: SlideInOut
};
/**
 * Component animating the child component in and out of view in different ways based on the type of
 * transition provided.
 */ const Transition = createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Transition', props, ref);
    const { initial, type = 'appear', ...elementProps } = mergedProps;
    if (!(type in transitionsMap)) throw new Error(`Invalid transition type: "${type}".`);
    const TransitionComponent = transitionsMap[type];
    return /*#__PURE__*/ jsx(TransitionComponent, {
        ...elementProps,
        ref: mergedRef,
        initial: initial
    });
});

export { Transition, transitionsMap };
//# sourceMappingURL=transition.js.map
